<template>
    <el-select :class="{ 'is-error': isError }" v-model="currentValue" v-bind="props" @change="inputHandler">
        <el-option v-for="item in props.options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
    </el-select>
</template>

<script>
import Validation from "../validation.js";
import { checkRule } from "@/views/zhiji/components/commonForm/rules.js";

export default {
    name: "Elselector",
    props: ["value", "widget", "validation", "rules"],
    data() {
        return {
            currentValue: this.value,
            isValid: true,
            message: "",
            myValidation: null
        };
    },
    watch: {
        value() {
            this.currentValue = this.value;
        }
    },
    computed: {
        props() {
            return this.widget.props;
        },
        isError() {
            return !this.isValid;
        }
    },
    created() {
        this.myValidation = new Validation({
            tiggerHanlder: () => this.validate(this.value),
            propName: this.widget.name
        });
        this.validation && this.validation.hasOwnProperty("addChild") && this.validation.addChild(this.myValidation);
    },
    destroyed() {
        this.myValidation && this.myValidation.destroy();
    },
    methods: {
        inputHandler(item) {
            this.$emit("change", item);
            this.verifyHandler(item);
        },
        verifyHandler(item) {
            this.validate(item);
            this.emitValid();
        },
        validate(newValue) {
            const rules = (this.rules || []).map(rule => {
                if (rule.required) {
                    return {
                        validator: val => {
                            if (val === undefined || val.length === 0) {
                                return false;
                            }
                            return true;
                        },
                        message: rule.message || "请选择！"
                    };
                }
                return rule;
            });
            if (rules.length === 0) {
                return;
            }
            const result = checkRule(newValue, rules);
            this.isValid = result.isValid;
            this.message = result.message;
            this.$emit("verify", result);
            return result;
        },
        emitValid() {
            this.myValidation && this.myValidation.emit({ isValid: this.isValid, message: this.message });
        }
    }
};
</script>

<style scoped lang="less">
.i-select {
    margin: 0;
}
.is-error {
    /deep/ input {
        border: 1px solid #f33535;
    }
}
/deep/.el-select__input {
    padding-left: 10px;
}
</style>
